import { Skeleton } from 'lighthouse';

import { BatteryChoiceCardLoadingProps } from './loadingModels';

export const BatteryChoiceCardLoading = ({ count = 4, className = '' }: BatteryChoiceCardLoadingProps) =>
    Array.from({ length: count }, (_, index) => (
        <div
            key={index}
            aria-hidden='true'
            className={`flex flex-col gap-2.5 rounded-2xl border border-solid border-N200 bg-white p-3 shadow-elevation1 ${className}`}>
            <div className='flex gap-3'>
                <Skeleton variant='rounded' width={64} height={64} className='shrink-0 rounded-xl' />
                <div className='flex min-w-0 flex-1 flex-col gap-0.5'>
                    <Skeleton variant='text' width={72} height={20} />
                    <Skeleton variant='text' width='95%' height={20} />
                    <Skeleton variant='text' width='70%' height={20} />
                    <Skeleton variant='text' width='85%' height={20} />
                </div>
            </div>
            <div className='flex gap-2'>
                <Skeleton variant='rounded' width={132} height={20} />
                <Skeleton variant='rounded' width={90} height={20} />
            </div>
            <div className='mt-auto flex items-center justify-between gap-3 border-t border-N100 pt-2.5'>
                <div>
                    <Skeleton variant='text' width={88} height={16} />
                    <Skeleton variant='text' width={132} height={24} />
                </div>
                <Skeleton variant='rounded' width={88} height={32} />
            </div>
        </div>
    ));
